import { render, staticRenderFns } from "./TreeEditRatificacionesDigital.vue?vue&type=template&id=1d2f6ae3&scoped=true"
import script from "./TreeEditRatificacionesDigital.vue?vue&type=script&lang=js"
export * from "./TreeEditRatificacionesDigital.vue?vue&type=script&lang=js"
import style0 from "./TreeEditRatificacionesDigital.vue?vue&type=style&index=0&id=1d2f6ae3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f6ae3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2f6ae3')) {
      api.createRecord('1d2f6ae3', component.options)
    } else {
      api.reload('1d2f6ae3', component.options)
    }
    module.hot.accept("./TreeEditRatificacionesDigital.vue?vue&type=template&id=1d2f6ae3&scoped=true", function () {
      api.rerender('1d2f6ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/TreeEditRatificacionesDigital.vue"
export default component.exports